import { useMutation } from '@tanstack/react-query';
import { addPet } from '../api/addPet';
import { editPet } from '../api/editPet';
import { IPet } from '@/shared/interfaces';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { toast } from '@/components';

type UsePetMutationProps = {
    pet?: IPet;
    onSuccess: () => void;
};

export const usePetModalMutation = ({
    pet,
    onSuccess,
}: UsePetMutationProps) => {
    const isEditing = !!pet;

    const addPetMutation = useMutation({
        mutationFn: addPet,
        onSuccess: () => onSuccess(),
        onError: () => {
            toast.addToast({
                type: 'error',
                message: R.ErrorAddPet,
            });
        },
    });

    const editPetMutation = useMutation({
        mutationFn: editPet,
        onSuccess: () => onSuccess(),
        onError: () => {
            toast.addToast({
                type: 'error',
                message: R.ErrorEditPet,
            });
        },
    });

    const onSubmit = (data: IPet) => {
        if (isPending) return;

        if (isEditing) {
            editPetMutation.mutate(data);
        } else {
            addPetMutation.mutate(data);
        }
    };

    const isPending = editPetMutation.isPending || addPetMutation.isPending;

    return {
        onSubmit,
        isPending,
    };
};
